module.exports = __webpack_public_path__ + "static/media/brush_11.781a9ec2.png";